import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-warranty',
  templateUrl: './warranty.component.html',
  styleUrls: ['./warranty.component.scss'],
  standalone: true
})
export class WarrantyComponent implements OnChanges {
  warrantyDetails: any;
  @Input() warrantyData: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['warrantyData']?.currentValue?.length) {
      this.getWarrantyData();
    }
  }

  getWarrantyData() {
    this.warrantyDetails = this.warrantyData[0].warranty;
  }
}